import { AxiosHeaders } from "axios";

import HlsApi from "./hls_api";
import HlsEncryption from "./hls_encryption";
import type { IHlsPreparedData } from "./hls_models";
import HlsParser from "./hls_parser";

interface IHlsManager {
  baseUrl?: string;
  headers?: AxiosHeaders;
}

class HlsManager {
  hlsApi: HlsApi;

  hlsParser = new HlsParser();
  hlsEncryption = new HlsEncryption();

  constructor({ baseUrl, headers }: IHlsManager) {
    this.hlsApi = new HlsApi({ baseUrl, headers });
  }

  getToken(): string | null {
    // const token = this.hlsApi.headers?.["Authorization"] as string | null;
    // return token?.split(" ")[1];
    return localStorage.getItem("splay:access");
  }

  async prepare(linkUrl: string): Promise<IHlsPreparedData> {
    const token = this.getToken();

    const linkData = await this.hlsApi.fetchLink(linkUrl);

    if (!linkData.link || !token) throw linkData;

    const encData = await this.hlsApi.fetchHlsEncData(linkData.link);

    const decData = this.hlsEncryption.decrypt(encData, token);

    return {
      url: this.hlsParser.parseToBlobUrl(decData),
      thumbnails: decData.thumbs_playlists
        ? this.hlsParser.parseThumbnails(decData.base_url, decData.thumbs_playlists)
        : undefined,
    };
  }
}

export default HlsManager;
